<template>
    <rkm-modal
        large
        ref="RkmModal"
        title="Histórico de atualização do cadastro"
    >

        <rkm-table
            v-if="data"
            :fields="fields"
            :items="handleHistorico"
        />

        <template v-slot:footer>
            <rkm-button @click="close">
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
export default {
    data: () => ({
        fields: [
            {
                class: 'col-min text-center',
                fixed: true,
                key: 'data',
                label: 'Data/Hora',
            },
            {key: 'usuario', label: 'Usuário', fixed: true },
            {key: 'equipe', label: 'Equipe do responsável', fixed: true },
        ],
    }),
    methods: {
        open() {
            this.$refs.RkmModal.show()
        },
        close() {
            this.$refs.RkmModal.hide()
        },
    },
    computed: {
        handleHistorico(){
            return this.data.form.historico
                .filter(item => item.data && item.usuario)
                .reverse()
        }
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>